<template>
  <div class="tab">
    <div class="top" style="text-align: left; padding-bottom: 10px; border-bottom: none;">
      <div class="position-right" v-if="this.alarms.length > 0">
        <download-excel class="button button-inline"
                        :fields="exportFields"
                        :data="excelData"
                        type="xls"
                        name="alarms.xls"
        >{{ $t('download-csv') }}</download-excel>
      </div>
      <table class="styled-table" v-if="this.alarms.length > 0">
        <tr>
          <th>{{ $t('date-time-year') }}</th>
          <th>{{ $t('Alarm') }}</th>
          <th>{{ $t('alarm-level') }}</th>
        </tr>
        <tr v-for="(item, index) in this.alarms" :key="index">
          <td>
            {{ item.created | formatDate }}
          </td>
          <td :class="'text-' + getAlarmLevel(item)">
            {{ getFullAlarmName(item) }}
          </td>
          <td :class="'text-' + getAlarmLevel(item)">
            {{ getAlarmLevel(item) }}
          </td>
        </tr>
      </table>
      <h2 v-else style="text-align: center">{{$t('No data found')}}</h2>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import moment from "moment";
import utils from "../plugins/utils";

export default {
  props: [],
  name: 'AlarmsList',
  data() {
    return {
      alarms: [],
      exportFields: {
        'Alarm time': 'created',
        'Alarm name': 'name',
        'Alarm additional info': 'additionalInfo',
      }
    }
  },
  computed: {
    ...mapState(['selectedPatient']),
    excelData() {
      let alarmsData = this.alarms.map((alarm) => {
        return {
          name: alarm.name,
          created: this.$options.filters.formatDate(alarm.created),
          additionalInfo: this.prepareMedicalInfoText(alarm)
        }
      });
      return [
        {created: `${this.$t('Patient name')}: ${this.selectedPatient.name}\n${this.$t('Report generated at')}: ${moment().toString()}`},
        {created: ''},
        {created: ''}
      ].concat(alarmsData);
    }
  },
  methods: {
    loadAlarms() {
      axios.get(`/api/medical/patients/${this.selectedPatient.id}/lastAlarms`).then(res => res.data.data).then(lastAlarms => {
        this.alarms = lastAlarms;
      });
      console.log('Loading alarms for patient', this.selectedPatient);
    },

    getFullAlarmName(alarm) {
      let additionalInfo = this.prepareMedicalInfoText(alarm);
      return alarm.name + (additionalInfo ? ` (${additionalInfo})` : '');
    },

    getAlarmLevel(alarm) {
      return alarm.additional_info && alarm.additional_info.level
    },

    prepareMedicalInfoText(alarm) {
      let text = '';
      if (alarm.additional_info) {
        if (alarm.additional_info.geofenceName) {
          text += alarm.additional_info.geofenceName + (alarm.additional_info.position ? `, ${alarm.additional_info.position}` : '');
        } else if (alarm.additional_info.temperature) {
          text += utils.prepareTempValue(alarm.additional_info.temperature)
        } else if (alarm.additional_info.medicalType) {
          text += `${this.$t(alarm.additional_info.medicalType)} ${alarm.additional_info.medicalThreshold}. ${this.$t('Value')}: ${alarm.additional_info.medicalValue}`;
        } else {
          text += JSON.stringify(alarm.additional_info);
        }
      }

      return text;
    }
  },
  watch: {
    selectedPatient(newVal, oldVal) { // watch it
      console.log('patient changed: ', newVal, ' | was: ', oldVal)
      this.loadAlarms();
    }
  },
  mounted() {
    this.loadAlarms();
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AlarmsList.vue